import { render, staticRenderFns } from "./modal-select-category.vue?vue&type=template&id=27eca74e&scoped=true"
import script from "./modal-select-category.vue?vue&type=script&lang=js"
export * from "./modal-select-category.vue?vue&type=script&lang=js"
import style0 from "./modal-select-category.vue?vue&type=style&index=0&id=27eca74e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27eca74e",
  null
  
)

export default component.exports